module.exports = __webpack_public_path__ + "img/logo.418a4933.png";